export enum AccidentType {
    // 1 - TÃ­pico
    TYPICAL = 'TYPICAL',
    // 2 - DoenÃ§a
    DISEASE = 'DISEASE',
    // 3 - Trajeto
    ROUTE = 'ROUTE'
}
